import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarQuickFilter
} from '@mui/x-data-grid';
import {
  MenuItem,
  Select,
  TextField,
  Button,
  InputLabel,
  FormControl,
  Box
} from '@mui/material';
import { TimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import ptLocale from 'date-fns/locale/pt';
import { format } from 'date-fns';
import JobsPlanner from '../api/JobPlanner';
import datagridPT from '../datagrid-pt';

const diasSemana = [
  { label: 'Domingo', value: 0 },
  { label: 'Segunda-feira', value: 1 },
  { label: 'Terça-feira', value: 2 },
  { label: 'Quarta-feira', value: 3 },
  { label: 'Quinta-feira', value: 4 },
  { label: 'Sexta-feira', value: 5 },
  { label: 'Sábado', value: 6 },
  { label: 'Todos os dias', value: 7 },
  { label: 'Mensalmente', value: 8 }, // NOVO
];

function JobPlanner() {
  const [jobs, setJobs] = useState([]);
  const [reference, setReference] = useState('');
  const [task, setTask] = useState('');
  const [hour, setHour] = useState(null);
  const [day, setDay] = useState(7);
  const [value, setValue] = useState('');

  const columns = [
    { field: 'task', headerName: 'Tarefa', flex: 2 },
    { field: 'type', headerName: 'Tipo', flex: 1 },
    { field: 'hour', headerName: 'Hora', flex: 1 },
    {
        field: 'day',
        headerName: 'Dia',
        flex: 1,
        valueGetter: (params) => {
            const dia = diasSemana.find(d => d.value === Number(params));
            return dia ? dia.label : '—';
        }
    },
    { field: 'last_ran_at', headerName: 'Última exec.', flex: 1 },
    {
      field: 'actions',
      headerName: 'Opções',
      width: 80,
      renderCell: (params) => (
        <button className="btn-primary-circle btn-delete" onClick={() => handleDelete(params.row.id)}>
          <FontAwesomeIcon icon={faTrash} />
        </button>
      )
    }
  ];

  useEffect(() => {
    fetchJobs();
  }, []);

  const fetchJobs = async () => {
    try {
      const { data } = await JobsPlanner.search();
      setJobs(data.data);
    } catch (err) {
      console.error('Erro ao obter jobs:', err);
    }
  };

  const handleDelete = async (id) => {
    try {
      await JobsPlanner.delete(id);
      fetchJobs();
    } catch (err) {
      console.error('Erro ao apagar job:', err);
    }
  };

  const handleSubmit = async () => {
    try {
      const formattedHour = hour ? format(hour, 'HH:mm:ss') : null;
      await JobsPlanner.create({
            reference,
            task,
            hour: formattedHour,
            day,
            type: reference,
            value: day === 8 ? value : null,
            is_active: true
        });
        setReference('');
        setTask('');
        setHour(null);
        setDay(7);
        fetchJobs();
        setValue('');
    } catch (err) {
      console.error('Erro ao criar job:', err);
    }
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarQuickFilter />
      </GridToolbarContainer>
    );
  }

  return (
    <div className="settings-container">
      <div className="container">
        <h2>Jobs</h2>

        <div className="table-container">
          <DataGrid
            rows={jobs}
            columns={columns}
            localeText={datagridPT}
            autoHeight
            pageSizeOptions={[5, 10, 25]}
            initialState={{
              pagination: { paginationModel: { pageSize: 10 } },
              sorting: { sortModel: [{ field: 'created_at', sort: 'desc' }] },
            }}
            disableSelectionOnClick
            slots={{ toolbar: CustomToolbar }}
          />
        </div>

        <h3 className="mt-4">Criar novos jobs</h3>
        <Box display="flex" gap={2} mt={2}>
          <TextField
            label="Referência"
            value={reference}
            onChange={(e) => setReference(e.target.value)}
            fullWidth
          />
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptLocale}>
            <TimePicker
                label="Hora"
                value={hour}
                onChange={(newValue) => setHour(newValue)}
                ampm={false}
                minutesStep={5}
                renderInput={(params) => <TextField {...params} fullWidth />}
            />
            </LocalizationProvider>

          <FormControl fullWidth>
            <InputLabel id="select-day-label">Dia</InputLabel>
            <Select
              labelId="select-day-label"
              value={day}
              label="Dia"
              onChange={(e) => setDay(e.target.value)}
            >
              {diasSemana.map((dia) => (
                <MenuItem key={dia.value} value={dia.value}>{dia.label}</MenuItem>
              ))}
            </Select>
            {day === 8 && (
                <TextField
                    label="Em que dia?"
                    type="number"
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    fullWidth
                    inputProps={{ min: 1, max: 31 }}
                />
            )}
          </FormControl>
        </Box>
        <Box mt={2}>
          <TextField
            label="Descrição"
            value={task}
            onChange={(e) => setTask(e.target.value)}
            multiline
            rows={4}
            fullWidth
          />
        </Box>
        <Box mt={2}>
          <Button variant="contained" color="success" onClick={handleSubmit}>
            GRAVAR
          </Button>
        </Box>
      </div>
    </div>
  );
}

export default JobPlanner;
